/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance, AxiosResponse } from "axios";

export function getServiceStatusAPI(
    api: AxiosInstance,
    tenantId: number,
    cfg?: any
): Promise<AxiosResponse> {
    return api.get(`kontroledge/monitoring/service-statuses-optimized?tenantId=${tenantId}`, cfg);
}

export function getServicesUsageAPI(
    api: AxiosInstance,
    tenantId: number,
    cfg?: any
): Promise<AxiosResponse> {
    return api.get(`/kontroledge/monitoring/usage-optimized-two?tenantId=${tenantId}&includeChildServices=true`, cfg);
}

export function getFailoverHistoryAPI(
    api: AxiosInstance,
    tenantId: number,
    cfg?: any
): Promise<AxiosResponse> {
    return api.get(`/kontroledge/monitoring/failover-history?tenantId=${tenantId}`, cfg);
}

/**
 * The whole Overview in one response (CTX-868): the four payloads below, keyed
 * `serviceStatus`, `usage`, `failover`, `maintenance`, plus `meta`. `baseUrl`
 * is absolute because the endpoint may live on another backend while it is
 * built (see getOverviewEndpointBaseUrl).
 */
export function getOverviewAPI(
    api: AxiosInstance,
    baseUrl: string,
    tenantId: number,
    cfg?: any
): Promise<AxiosResponse> {
    return api.get(`${baseUrl}/v1/kontroledge/overview?tenantId=${tenantId}`, cfg);
}

export function getMonitoringAPI(
    api: AxiosInstance,
    tenantId: number,
    cfg?: any
): Promise<AxiosResponse> {
    return api.get(`/kontroledge/monitoring/maintenance?tenantId=${tenantId}`, cfg);
}
